// extracted by mini-css-extract-plugin
module.exports = {"extend-board-column":"_1HwI0ZIBG9TBkHR6gCvp","full-width-button":"_3hX-x0PksCb2CTeII2S2"};